/**
 * Client-side mirror of orchestrator/src/auth/password-policy.ts.
 *
 * Both sides must stay in lockstep: the backend is the source of truth, but
 * surfacing the rules to the user up front (with a precise reason) is much
 * better UX than waiting for a round-trip and rendering a generic
 * "invalid body" from the server's Zod validator.
 */

export const MIN_PASSWORD_LENGTH = 10;

/** Returns the first failing rule's message, or null when the password is valid. */
export function validatePassword(s: string): string | null {
  if (s.length < MIN_PASSWORD_LENGTH) {
    return `Password must be at least ${MIN_PASSWORD_LENGTH} characters.`;
  }
  if (s.length > 200) {
    return 'Password is too long.';
  }
  if (!/[A-Za-z]/.test(s)) {
    return 'Password must include at least one letter.';
  }
  if (!/[0-9]/.test(s)) {
    return 'Password must include at least one digit.';
  }
  return null;
}

/** Helper text shown under password fields. */
export const PASSWORD_HINT = `At least ${MIN_PASSWORD_LENGTH} characters with a letter and a digit.`;
